/**
 * Фасовка рядом с количеством в степпере: `1` + `× 120 g`, `2` + `kg` (этикетка «1 kg»).
 * Литр пишется `L`: одинокая строчная `l` читается как вертикальная черта.
 */
export function packSizeDetail(sizeLabel: string | null | undefined): string | null {
  const trimmed = sizeLabel?.trim();
  if (!trimmed) return null;
  const label = trimmed.replace(/\bl\b/g, 'L');
  const single = /^1(?:[.,]0+)?\s+([^\d×x].*)$/.exec(label);
  if (single?.[1]) return single[1];
  return `× ${label}`;
}
